const ResultsParams = `
adultsCount
arrival
ascending
childrenCount
currency
departure
filter
filterByTotalPrice
locale
maxBathrooms
maxBedrooms
maxNightlyPrice
maxTotalPrice
minBathrooms
minBedrooms
minNightlyPrice
minTotalPrice
neLat
neLong
orderBy
page
petIncluded
pinnedPropertyListing
q
regionId
searchbucket
searchTermUuid
swLat
swLong
zoom
`
    .trim()
    .split(/\s+/);

module.exports = {ResultsParams};
